module.exports = __webpack_public_path__ + "img/h.f1470ce6.jpg";